export const RadioList = ({ legend, name, options, value, onChange, testId }) => (
  <fieldset data-testid={testId} className="m-0 min-w-0 border-0 p-0">
    <legend className="p-0 text-sm font-medium leading-5 text-ax-text">{legend}</legend>
    <div className="mt-2 flex flex-col gap-2" role="radiogroup" aria-label={legend}>
      {options.map((o) => {
        const on = value === o.value;
        return (
          <label key={o.value} className="relative block">
            <input
              type="radio"
              name={name}
              value={o.value}
              checked={on}
              onChange={() => onChange(o.value)}
              data-testid={`${testId}-${o.key ?? o.value}`}
              className="peer sr-only"
            />
            <span
              className={`flex min-h-[48px] cursor-pointer items-center gap-3 rounded-[8px] border px-3 py-2 text-base leading-6 transition-colors duration-150 peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-ax-focus-ring ${
                on ? "tint-chip-active text-ax-text" : "border-ax-border bg-ax-surface text-ax-text hover:bg-ax-bg"
              }`}
            >
              <span
                aria-hidden="true"
                className={`box-border flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${
                  on ? "border-ax-accent" : "border-ax-muted"
                }`}
              >
                {on && <span className="block h-2 w-2 rounded-full bg-ax-accent" />}
              </span>
              <span className="min-w-0 [overflow-wrap:anywhere]">{o.label}</span>
            </span>
          </label>
        );
      })}
    </div>
  </fieldset>
);
